import Clipboard from 'clipboard';

let shareSocialsTrigger = document.getElementById("share-social-toggle");
let socials = document.getElementById("share-social");

if (shareSocialsTrigger) {
    shareSocialsTrigger.addEventListener("click", function () {
        socials.classList.toggle("share__social--open");
        this.setAttribute(
            "aria-expanded",
            `${!(this.getAttribute("aria-expanded") === "true")}`
        );
    });

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
            socials.classList.remove("share__social--open");
            shareSocialsTrigger.setAttribute("aria-expanded", "false");
        }
    });

    new Clipboard('#copy-clipboard');
}